import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { CorpDetailModel } from "models";
import React from "react";

type PROPS = {
  data: CorpDetailModel;
};

const CorpDetailMap: React.FC<PROPS> = (props) => {
  const address = React.useRef("");
  const [center, setCenter] = React.useState({
    lat: 35.681236,
    lng: 139.767125,
  });
  const [isShowMarker, setIsShowMarker] = React.useState(false);

  const libraries = React.useRef<
    ("geometry" | "drawing" | "localContext" | "places" | "visualization")[]
  >(["geometry", "drawing"]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY ?? "",
    libraries: libraries.current,
  });

  React.useEffect(() => {
    if (!process.env.REACT_APP_GOOGLE_MAP_API_KEY) {
      return;
    }

    let n = 0;
    const intervalId = setInterval(() => {
      console.log(`interval:${n}`);
      n++;
      if (n > 3) {
        clearInterval(intervalId);
      }
      if (!window.google?.maps) {
      } else {
        if (
          address.current ===
          props.data.prefecture_name + props.data.address
        ) {
          // すでにMAP表示済
          clearInterval(intervalId);
        } else {
          address.current = props.data.prefecture_name + props.data.address;
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ address: address.current }, (results, status) => {
            // console.log(results, status);
            if (status === "OK") {
              if (results) {
                const lat = results[0].geometry.location.lat();
                const lng = results[0].geometry.location.lng();
                console.log(
                  `検索住所: ${address.current}\n結果: ${
                    results[0].formatted_address
                  }\n緯度: ${lat.toFixed(3)} 経度: ${lng.toFixed(3)}`
                );
                // console.log(lat, lng);
                setCenter({ lat, lng });
                setIsShowMarker(true);
              }
            }
          });
        }
      }
    }, 300);
  }, [props.data]);

  if (!isLoaded || !address.current) {
    return <></>;
  }

  return (
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "40vh" }}
      center={center}
      zoom={18}
    >
      {isShowMarker && <Marker position={center} />}
    </GoogleMap>
  );
};

export default CorpDetailMap;
